import { Check } from "lucide-react";

const steps = ["Connect", "Select region", "Build", "Review"] as const;

export function WorkflowHeader({ activeStep, demo }: { activeStep: number; demo: boolean }) {
  return (
    <header className="workflow-header">
      <div className="brand" aria-label="map2threejs">
        <strong>map2</strong><span>threejs</span>
      </div>
      <nav className="workflow-steps" aria-label="Build progress">
        {steps.map((label, index) => {
          const step = index + 1;
          const complete = step < activeStep;
          const active = step === activeStep;
          return (
            <div className={`workflow-step ${active ? "active" : ""} ${complete ? "complete" : ""}`} key={label}>
              <span className="step-index" aria-hidden="true">{complete ? <Check size={16} strokeWidth={2.5} /> : step}</span>
              <span>{label}</span>
              {step < steps.length && <span className="step-line" aria-hidden="true" />}
            </div>
          );
        })}
      </nav>
      <div className="header-mode">{demo ? "Demo fixture" : "Private browser session"}</div>
    </header>
  );
}
